// Initialize Swiper carousels
function initSwipers() {
  const swipers = document.querySelectorAll('.swiper')
  const swiperObjects = []
  swipers.forEach(function(element) {
    const container = element.closest('[data-slider-container]')
    
    // Destroy existing Swiper instances if they exist
    if (element.swiper) {
      element.swiper.destroy(true, true);
    }
    
    let thumbsElement = container.querySelector('[data-swiper-thumbs]')
    if(thumbsElement) {
      // Destroy existing thumbnail Swiper instance if it exists
      if (thumbsElement.swiper) {
        thumbsElement.swiper.destroy(true, true);
      }
      thumbs = new Swiper(thumbsElement, {
        slidesPerView: 7,
      })
    }
    swiperObjects.push( 
      new Swiper(element, {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination'
        },
        thumbs: {
          swiper: thumbs
        }
      })
    )
    setTimeout(function() {
      const slides = element.querySelectorAll('[data-variant-media],[data-media-id]')
      slides.forEach(function(slide) { slide.classList.remove('sr-only')})
      if(thumbs) {
        thumbsElement.classList.remove('sr-only')
      }
    }, 100)
  })

}

document.addEventListener('DOMContentLoaded', function() {
  // Check if Swiper is available globally
  if (typeof Swiper !== 'undefined') {
    initSwipers()
  } else {
    console.error('Swiper is not loaded. Please include Swiper library.')
  }
  
  // Set up event listeners for any existing product-info elements
  setupProductInfoListeners()
})

// Function to set up product-info event listeners
function setupProductInfoListeners() {
  const productInfoElements = document.querySelectorAll('product-info')
  
  productInfoElements.forEach(function(element) {
    element.addEventListener('variant:update-media', function(event) {
      if (typeof Swiper !== 'undefined') {
        initSwipers()
      }
    })
  })
}
